var _circle, _circle2, _rect, _path, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPayment(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 31.5,
    fill: "white",
    stroke: "#47bba9"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 28,
    fill: "rgba(71, 187, 169, 0.3)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 40,
    width: 24,
    height: 24,
    rx: 12,
    fill: "#47bba9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.0007 45.334C48.3207 45.334 45.334 48.3207 45.334 52.0007C45.334 55.6807 48.3207 58.6673 52.0007 58.6673C55.6807 58.6673 58.6673 55.6807 58.6673 52.0007C58.6673 48.3207 55.6807 45.334 52.0007 45.334ZM49.8207 49.1073C50.3607 49.1073 50.8073 49.5473 50.8073 50.094C50.8073 50.634 50.3673 51.0807 49.8207 51.0807C49.2807 51.0807 48.834 50.6407 48.834 50.094C48.834 49.5473 49.274 49.1073 49.8207 49.1073ZM49.9007 54.534C49.8007 54.634 49.674 54.6807 49.5473 54.6807C49.4207 54.6807 49.294 54.634 49.194 54.534C49.0007 54.3407 49.0007 54.0207 49.194 53.8273L53.5607 49.4607C53.754 49.2673 54.074 49.2673 54.2673 49.4607C54.4607 49.654 54.4607 49.974 54.2673 50.1673L49.9007 54.534ZM54.1807 54.894C53.6407 54.894 53.194 54.454 53.194 53.9073C53.194 53.3673 53.634 52.9207 54.1807 52.9207C54.7207 52.9207 55.1673 53.3607 55.1673 53.9073C55.1673 54.454 54.7273 54.894 54.1807 54.894Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_90_14352)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_90_14352)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.667 44V22.6667C22.667 21.9594 22.9479 21.2811 23.448 20.781C23.9481 20.281 24.6264 20 25.3337 20H38.667C39.3742 20 40.0525 20.281 40.5526 20.781C41.0527 21.2811 41.3337 21.9594 41.3337 22.6667V44L37.3337 41.3333L34.667 44L32.0003 41.3333L29.3337 44L26.667 41.3333L22.667 44Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.667 44V22.6667C22.667 21.9594 22.9479 21.2811 23.448 20.781C23.9481 20.281 24.6264 20 25.3337 20H38.667C39.3742 20 40.0525 20.281 40.5526 20.781C41.0527 21.2811 41.3337 21.9594 41.3337 22.6667V44L37.3337 41.3333L34.667 44L32.0003 41.3333L29.3337 44L26.667 41.3333L22.667 44Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_90_14352)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.6663 26.667H31.333C30.8026 26.667 30.2939 26.8777 29.9188 27.2528C29.5437 27.6279 29.333 28.1366 29.333 28.667C29.333 29.1974 29.5437 29.7061 29.9188 30.0812C30.2939 30.4563 30.8026 30.667 31.333 30.667H32.6663C33.1968 30.667 33.7055 30.8777 34.0806 31.2528C34.4556 31.6279 34.6663 32.1366 34.6663 32.667C34.6663 33.1974 34.4556 33.7061 34.0806 34.0812C33.7055 34.4563 33.1968 34.667 32.6663 34.667H29.333M31.9997 34.667V36.667M31.9997 24.667V26.667",
    stroke: "#05569F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    shapeRendering: "crispEdges"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_90_14352",
    x: 19.667,
    y: 17,
    width: 28.667,
    height: 34,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.439216 0 0 0 0 0.396078 0 0 0 0 0.941176 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_90_14352"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_90_14352",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_90_14352",
    x: 26.333,
    y: 21.667,
    width: 15.333,
    height: 22,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.439216 0 0 0 0 0.396078 0 0 0 0 0.941176 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_90_14352"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_90_14352",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_90_14352"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(16 16)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayment);
export default __webpack_public_path__ + "static/media/payment.e53d0a8bfbb4b712ac550467e0b98333.svg";
export { ForwardRef as ReactComponent };